var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHotleads(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    fill: "#9E9191"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1159 20.6202C38.7935 18.6768 37.3297 16.551 37.3297 14.1018C37.3297 13.9094 36.8244 14.5516 36.7918 14.594C36.4306 15.1073 36.1594 15.6783 35.9899 16.2826C35.2557 18.8379 36.3629 21.6129 35.9801 24.2399C35.6653 26.4006 34.0911 28.6059 32.0355 29.4197C29.4116 30.4583 27.5344 28.738 27.1264 26.1829C26.7467 23.8046 27.3563 21.1517 25.744 19.0992C25.7081 19.0536 25.1441 18.3364 25.1441 18.5516C25.0763 20.972 23.8208 23.1269 22.6357 25.1628C19.075 31.28 17.1762 40.1273 22.0233 46.1139C27.4893 52.8651 38.3424 52.3633 43.2791 45.273C44.8449 43.0052 45.7306 40.3375 45.8321 37.5836C46.126 31.6459 43.338 25.3556 40.1159 20.6202Z",
    fill: "#FFBF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotleads);
export default __webpack_public_path__ + "static/media/hotleads.2df69d0d6c51cc2af78b17423cf85db6.svg";
export { ForwardRef as ReactComponent };